module.exports = __webpack_public_path__ + "img/Image-3.811e6f12.png";